import { UserFilter } from "@coaching-culture/types";
import {
  Box,
  EmptyState,
  Flex,
  Loader,
  Panel,
  PanelHeader,
  Text,
} from "@coaching-culture/ui";
import { DualOptionSelect } from "pages/Solutions/DualOptionSelect";
import { MeasuresTable } from "pages/Solutions/MeasuresTable";
import { useMeasures, useAllUserMeasures } from "queries/measures";
import { useEffect, useState } from "react";
import { FaChartLine } from "react-icons/fa";

type MeasuresInsightsComparisonProps = {
  filter: UserFilter;
};

export const MeasuresInsightsComparison = ({
  filter,
}: MeasuresInsightsComparisonProps) => {
  const [selected, setSelected] = useState<[string, string]>(["", ""]);
  const measures = useMeasures();
  const userMeasures = useAllUserMeasures(filter);

  useEffect(() => {
    if (measures.data) {
      setSelected([measures.data?.[0].id ?? "", measures.data?.[1].id ?? ""]);
    }
  }, [measures.data]);

  const loading = !measures.isSuccess || !userMeasures.isSuccess;

  const noData = measures.data?.length < 2;

  return (
    <Panel mb={3}>
      <PanelHeader alignItems={"center"}>
        <Text fontSize="title" fontWeight={600} color="black">
          Measures insights
        </Text>
      </PanelHeader>
      {loading ? (
        <Loader />
      ) : noData ? (
        <EmptyState icon={FaChartLine} compact>
          Comparisons need at least two measures.
        </EmptyState>
      ) : (
        <Flex p={3} alignItems={"center"} flexDirection={["column", "row"]}>
          <Box p={4} ml={2} mr={5}>
            <DualOptionSelect
              options={measures.data.map((x) => ({
                value: x.id,
                label: x.name,
              }))}
              value={selected}
              onChange={setSelected}
            />
          </Box>
          <Box overflowX={"auto"} flex="1">
            <MeasuresTable
              comparison={selected}
              measures={measures.data}
              userMeasures={userMeasures.data}
            />
          </Box>
        </Flex>
      )}
    </Panel>
  );
};
